var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.38325C5 3.48697 5.02752 3.57744 5.08202 3.65321L7.30623 6.49925L5.08202 9.34532C5.02752 9.42182 5 9.51156 5 9.61528C5 9.719 5.02752 9.80874 5.08202 9.88524C5.13706 9.96174 5.20427 10 5.28206 10C5.35985 10 5.43129 9.96248 5.49374 9.88524L7.91745 6.76113C7.97248 6.69566 8 6.60886 8 6.49999C8 6.39112 7.97248 6.3036 7.91745 6.23813L5.49374 3.11402C5.43129 3.03825 5.36038 3 5.28206 3C5.20374 3 5.13706 3.03825 5.08202 3.11402C5.02752 3.19052 5 3.28026 5 3.38398L5 3.38325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.84139e-07 6.49966C-1.27465e-07 10.0839 2.91553 13 6.5 13C10.0845 13 13 10.0839 13 6.49966C13 2.91538 10.0838 -4.40777e-07 6.5 -2.84124e-07C2.9162 -1.27471e-07 -4.40784e-07 2.91604 -2.84139e-07 6.49966ZM12.3922 6.49966C12.3922 9.7485 9.749 12.3916 6.5 12.3916C3.251 12.3916 0.607818 9.7485 0.607817 6.49966C0.607817 3.25082 3.251 0.60778 6.5 0.60778C9.749 0.60778 12.3922 3.25082 12.3922 6.49966Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.3881e400dcd6eddb13b55dc0e0d9c40d.svg";
export { ForwardRef as ReactComponent };